module.exports = __webpack_public_path__ + "img/turbina.f59afcae.svg";